const serviceScript = () => {

  // レスポンシブ関連
  $(function () {
    var windowWidth = $(window).width();
    var windowSm = 667;

    if (windowWidth <= windowSm) { // スマホ時のjQuery

      // 固定フッターの設定
      $(document).ready(function() {

        var kotei_foot = $('.kotei-foot-link');

        $(window).scroll(function () {
          if ($(this).scrollTop() > 200) {
            kotei_foot.addClass('fadein');
          } else {
            kotei_foot.removeClass('fadein');
          }
        });

      });

      $(function(){
        $(window).scroll(function (){
          $('.foot-in-logo-img').each(function(){
            var position = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > position - windowHeight){
              $('.kotei-foot-link').removeClass('fadein');
            }
          });
        });
      });

    } else { // PC・タブレット時のjQuery

    }
  });
};

export default {
  serviceScript,
};